export default __webpack_public_path__ + "static/media/Enlist_logo.ecdf24dd.png";